import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/Navbar";
import { useAuth } from "@/context/AuthContext";
import { Clock, Mail } from "lucide-react";

export default function PendingApproval() {
  const { user } = useAuth();
  return (
    <PublicLayout>
      <div className="mx-auto max-w-lg px-4 py-28 text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-[#D4AF37]/30 bg-[#D4AF37]/10">
          <Clock className="h-9 w-9 text-[#D4AF37]" />
        </div>
        <h1 className="mt-6 font-serif-display text-3xl font-bold text-slate-50">Account under review</h1>
        <p className="mt-3 text-sm text-[#94A3B8]">
          Hi {user?.name || "there"}, your trade account for <span className="text-slate-200">{user?.company_name}</span> is being reviewed by our team.
          Trade pricing and ordering unlock as soon as you're approved.
        </p>
        <div className="mt-8 flex items-center justify-center gap-2 rounded-xl border border-[#2A2E39] bg-[#1A1D24] px-5 py-4 text-sm text-[#94A3B8]">
          <Mail className="h-4 w-4 text-[#D4AF37]" /> We'll notify you at {user?.email}
        </div>
        <Link to="/catalog" className="mt-8 inline-block text-sm text-[#D4AF37]">Browse the public catalogue</Link>
      </div>
    </PublicLayout>
  );
}
